import Dexie, { Table } from "dexie";

export interface ProductServing {
  productId: string;
  servingSize: number;
}

export interface Meal {
  id?: string; // Dexie will auto-generate if not provided
  eatenAt: string; // ISO string with date + time
  products: ProductServing[];
  createdAt: string;
  updatedAt?: string;
}

export interface User {
  id?: string;
  firstName: string;
  lastName: string;
  gender: string;
  bornDate: string;
  weight: number;
  height: number;
  activityLevel: string;
  email: string;
  phone: string;
  createdAt: string;
  updatedAt: string;
}

export interface Setting {
  key: string;
  value: any;
  updatedAt: string;
}

export class AppDB extends Dexie {
  meals!: Table<Meal, string>;
  users!: Table<User, string>;
  settings!: Table<Setting, string>;

  constructor() {
    super("app-db");
    this.version(1).stores({
      meals: "++id, date, createdAt",
    });
    this.version(2)
      .stores({
        meals: "++id, eatenAt, createdAt",
      })
      .upgrade(async (trans) => {
        const meals = await trans.table("meals").toArray();
        await Promise.all(
          meals.map(async (meal: any) => {
            if (!meal.eatenAt) {
              let eatenAt = meal.createdAt;
              if (meal.date) {
                let timePart = "T00:00:00.000Z";
                if (meal.createdAt && meal.createdAt.length >= 19) {
                  timePart = meal.createdAt.substring(10);
                }
                eatenAt = meal.date + timePart;
              }
              await trans.table("meals").update(meal.id, { eatenAt });
            }
          })
        );
        console.log("Dexie v2 migration: meals.eatenAt migration complete");
      });
    this.version(3).stores({
      meals: "++id, eatenAt, createdAt",
      users: "++id, firstName, lastName, gender, bornDate, weight, height, activityLevel, createdAt, updatedAt",
    });
    this.version(4).stores({
      meals: "++id, eatenAt, createdAt",
      users: "++id, firstName, lastName, gender, bornDate, weight, height, activityLevel, email, phone, createdAt, updatedAt",
    });
    this.version(5).stores({
      meals: "++id, eatenAt, createdAt",
      users: "++id, firstName, lastName, gender, bornDate, weight, height, activityLevel, email, phone, createdAt, updatedAt",
      settings: "key, value, updatedAt"
    });
  }
}

export const db = new AppDB();
